import React, {useRef, useState, useEffect} from 'react';
import root from 'window-or-global';
import PropTypes from 'prop-types';
import {generateRoutePath} from 'epic-common/src/route';
import {Link} from 'react-router-dom';
import Message from '../message/Message';


const StickyHeader = ({backUrl, title, time, image}) => {
    const [sticky, setSticky] = useState(false);
    const headerRef = useRef();
    const handleScroll = (headerHeight) => {
        if (root.pageYOffset > headerHeight) {
            setSticky(true)
        } else {
            setSticky(false)
        }
    }
    useEffect(() => {
        if(root.__server_side_render) return;
        const headerHeight = headerRef.current.offsetTop + headerRef.current.offsetHeight;
        root.addEventListener('scroll', () => {handleScroll(headerHeight)})
    },[])
    const bgImg = image ? {backgroundImage: `url(${image})`} : null;
    const className = sticky ? "sticky-header sticky" : "sticky-header";
    return (
        <div className={className} style={bgImg} ref={headerRef} >
            <div className="sticky-nav">
                <Link className="back-link" to={generateRoutePath(backUrl)}><Message code="epic.ut.tutorial.sticky.back" /></Link>
                <div className="sticky-content">
                    <h4>{title}</h4>
                    {time && <Message className="tutorial-time-label" code="epic.ut.tutorial.sticky.about" args={[time]} />}
                </div>
            </div>
        </div>
    )
}

StickyHeader.propTypes = {
    backUrl: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.string,
    image: PropTypes.string
}

export default StickyHeader

